import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// TODO only in ionic? maybe also use in backoffice?
// TODO refactorize it to signals

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  // TODO create interface
  private readonly errorSubject = new BehaviorSubject<{
    message?: string;
    status?: number;
    detail?: string;
  } | null>(null);

  // constructor() {}

  public error$ = this.errorSubject.asObservable();

  public setError(error: { message?: string; status?: number; detail?: string }): void {
    this.errorSubject.next(error);
  }

  public clearError(): void {
    this.errorSubject.next(null);
  }
}
